import { render, staticRenderFns } from "./Webaside.vue?vue&type=template&id=60ae894c&ref=cpt_aside"
import script from "./Webaside.vue?vue&type=script&lang=js"
export * from "./Webaside.vue?vue&type=script&lang=js"
import style0 from "./Webaside.vue?vue&type=style&index=0&id=60ae894c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports